<template>
  <div :class="`col-12 lg:col-${lg_col} xl:col-${xl_col}`">
    <div class="card mb-0">
      <div class="flex justify-content-between mb-3">
        <div>
          <span class="block text-500 font-medium mb-3">{{ title }}</span>
          <div class="text-900 font-medium text-xl">
            {{ value }}
          </div>
        </div>
        <div
          :class="`flex align-items-center justify-content-center ${color} border-round`"
          style="width: 2.5rem; height: 2.5rem"
        >
          <i :class="`pi pi-${icon} text-blue-500 text-xl`"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "value", "icon", "color", "xl_col", "lg_col"],
};
</script>

<style></style>
